import { useRef, useState } from 'react';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import {
  DropDownBtnsContainer,
  ButtonContainer,
  Container,
  DropDownContainer,
  EditButton,
  TableIconBtn,
} from './Table.style';

const EditButtons = ({ editButtons }) => {
  const [isOpened, setIsOpened] = useState(false);
  const containerRef = useRef();
  useOnClickOutside(containerRef, () => setIsOpened(!isOpened), isOpened);

  return (
    <Container>
      <ButtonContainer isOpened={isOpened} onClick={() => setIsOpened(!isOpened)}>
        <TableIconBtn icon={'"\\e909"'} />
      </ButtonContainer>
      <DropDownContainer ref={containerRef} isOpened={isOpened}>
        <DropDownBtnsContainer>
          {editButtons?.map(({ btnId, btnIcon, btnLabel, btnFn, ...rest }) => (
            <EditButton
              key={btnId}
              icon={btnIcon}
              color={rest?.btnTextColor}
              onClick={() => {
                btnFn();
                setIsOpened(false);
              }}
            >
              {btnLabel}
            </EditButton>
          ))}
        </DropDownBtnsContainer>
      </DropDownContainer>
    </Container>
  );
};

export default EditButtons;
